import { IRegionShort } from 'api/region/types';
import { Routes } from 'routes';
import { OuterPlanYourTripPropsType } from './types';
import { PlanYourTrip } from './Component';
import { hasWeSkiIntegration, weSkiDestinationId } from './WeSki/resolver';

interface IRegionPlanYourTripProps extends OuterPlanYourTripPropsType {
  region: IRegionShort,
  templateName?:string;
}

const PlanYourTripRegionWrapper = ({
  region,
  templateName,
  ...props
}: IRegionPlanYourTripProps) => {
  const redirectLodgingPath = Routes.regionLodging(region);
  const redirectSkiRentalPath = '';
  const { title } = region;

  const lodgingProvider = hasWeSkiIntegration({ regionId: region.uuid }) ? 'weski' : 'tripadvisor';
  const weDestinationId = lodgingProvider === 'weski' ? weSkiDestinationId({ regionId: region.uuid }) : null;

  return (
    <PlanYourTrip
      {...props}
      contextKey="region"
      title={title}
      redirectLodgingPath={redirectLodgingPath}
      redirectSkiRentalPath={redirectSkiRentalPath}
      lodgingProvider={lodgingProvider}
      weSkiDestinationId={weDestinationId}
      templateName={templateName}
    />
  );
};

export default PlanYourTripRegionWrapper;
